import type { ThreadItem } from "../-hooks/useChatThreadView";

/**
 * Every image in the thread that native can load, in thread order (oldest
 * first), for the native image viewer to page through. Images that are still
 * uploading only have a `blob:` URL inside this page, so they are left out.
 */
export function collectThreadImageUrls(items: readonly ThreadItem[]): string[] {
    // One visit per attachment: the inner flatMap keeps a URL as `[url]` and
    // drops everything else as `[]`, so no intermediate arrays are built.
    const urls = items.flatMap((item) =>
        (item.message.attachments ?? []).flatMap((attachment) =>
            attachment.mimeType.startsWith("image") &&
            attachment.url !== undefined &&
            isHttpUrl(attachment.url)
                ? [attachment.url]
                : [],
        ),
    );

    return [...new Set(urls)];
}

function isHttpUrl(url: string): boolean {
    return url.startsWith("https://") || url.startsWith("http://");
}
